module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_uneedcom_m.cd91c4e40c06ef46efb2dc37d098e5ac.png";